export default {
  GET: ({ response }) => ({
    ...response,
    json: response.body,
  }),
};
